<template>
    <div>
        <h2 class="text-center thank-you-heading">Terms And Conditions</h2>
        <p class="text-center paragraph" style="padding: 0px">
            Please read our
            <a
                target="_blank"
                href="https://www.idenfodirect.com/wp-content/uploads/2021/08/Idenfo-Direct-TC.pdf"
                >Privacy Policy</a
            >. By proceeding, you are agreeing to how we use your data.
        </p>
        <div class="row justify-content-center">
            <!-- <b-button
    type="submit"
    variant="primary"
    :class="loading ? 'disabled primary-add-btn' : ' primary-add-btn'"
    @click="agreeToTermsAndConditions"
>
    <span class="btn-text">I Agree</span>
    <span class="loader"></span>

</b-button> -->
            <popup-button
                btn-type="button"
                btn-variant="primary"
                btn-label="I Agree"
                :class="loading ? 'disabled' : ''"
                :disabled="loading"
                @onClickButton="agreeToTermsAndConditions"
            ></popup-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PopupButton from '@/components/registration/PopupButton.vue'

export default {
    components: {
        PopupButton,
    },
    methods: {
        agreeToTermsAndConditions() {
            this.$emit('agreed')
        },
    },
    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > methods

    /*
|--------------------------------------------------------------------------
| Component > mounted
|--------------------------------------------------------------------------
*/
}
</script>
